import React from "react";
import styles from "./Input.module.css";
import type { inputProps } from "./types.props";

const Input: React.FC<inputProps> = ({ label, id, error, ...props }) => {
    const finalInputClass = `${styles["form-input"]} ${error ? styles.error : ""}`;

    return (
        <div className={`${styles["input-group"]}`}>
            <label htmlFor={id} className={`${styles["input-label"]}`}>
                {label}
            </label>
            <input id={id} className={finalInputClass} {...props} />
            {error && (
                <div className={styles["input-message"]}>
                    <span className={styles["input-message--error"]}>{error}</span>
                </div>
            )}
        </div>
    );
};

export default Input;
